import React from 'react';
import { Container } from 'react-bootstrap';

export const DeveloperPaymentsPages = () => {
  return <Container className="startpage">DeveloperPaymentsPages</Container>;
};
